module.exports = __webpack_public_path__ + "img/26_107.ae850a78.png";